$("#form-fr-pincode").submit(function (e) {
  $("#name").text($("#name-input").val());
  $("#shipping-text-hide").hide();
  $("#hidden-show").show();

  // Prevent reload page
  e.preventDefault();
});

function getFormattedDate(date) {
  let monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  let day = date.getDate();
  let month = monthNames[date.getMonth()];
  let year = date.getFullYear();

  return `${day}, ${month}, ${year}`;
}

function addDaysToDate(date, daysToAdd) {
  let newDate = new Date(date);
  newDate.setDate(date.getDate() + daysToAdd);

  return newDate;
}

let todaysDate = new Date();
let oneYearFromToday = addDaysToDate(todaysDate, 365);
let tenDaysAfterToday = addDaysToDate(todaysDate, 3);

$("#today").html("Today's date is: " + getFormattedDate(todaysDate));
$("#one-year-ahead").html(
  "The date one year ahead is: " + getFormattedDate(oneYearFromToday)
);
$("#three-days-ahead").html("" + getFormattedDate(tenDaysAfterToday));
